import Dropzone, { useDropzone } from 'react-dropzone';
import React, { useState } from 'react';
import { faImage, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import { useUploadController } from 'src/controllers/ImageUpload/UploadController';
import { useData } from 'src/contexts/data';

import './styles.scss';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import LoadingScreen from '../LoadingScreen';
import { ModelOfImageFromDb } from 'src/database';

const DropzoneScreen: React.FC = () => {
	const { loadingImage, imagesData, imagePreview, fileImagesUpload, disable, handleDelete, handleRmFromServer } =
		useData();
	const { handleUpload } = useUploadController();
	const [isDragActive, setIsDragActive] = useState(false);
	const [isDropAccept, setIsDropAccept] = useState(false);
	const [isDropReject, setIsDropReject] = useState(false);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [selectedImage, setSelectedImage] = useState<ModelOfImageFromDb | null>(null);

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({});

	const handleDialog = (imageId?: ModelOfImageFromDb) => {
		imageId ? setSelectedImage(imageId) : setSelectedImage(null);
		setDialogOpen(!dialogOpen);
	};

	const deleteVehicleDialogFooter = () => (
		<React.Fragment>
			<Button
				label='Não'
				icon='pi pi-times'
				className='p-button-text'
				onClick={() => {
					handleDialog();
				}}
			/>
			<Button
				label='Sim'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					handleRmFromServer(selectedImage);
					handleDialog();
				}}
			/>
		</React.Fragment>
	);

	return (
		<div className='baseStyle'>
			{loadingImage ? <LoadingScreen color='#0388e5' /> : <></>}
			<Dropzone
				onDragEnter={() => setIsDragActive(true)}
				onDropRejected={() => setIsDropReject(true)}
				onDropAccepted={() => setIsDropAccept(true)}
				onDrop={handleUpload.handleUploadImage}
				noDrag={disable}
				accept='image/*'>
				{({ getRootProps, getInputProps }) => {
					return (
						<section
							{...getRootProps()}
							style={!disable ? { cursor: 'pointer' } : { cursor: 'default' }}
							className='uploadZone'>
							<div
								className={classNames({
									activeStyle: isDragActive,
									acceptStyle: isDropAccept,
									rejectStyle: isDropReject,
								})}>
								<input {...getInputProps()} />
								{isDropReject ? <p>O tipo do arquivo não é permitido</p> : <></>}

								{!isDragActive && !disable ? (
									<p>Arraste e solte o arquivo aqui, ou clique para escolher</p>
								) : (
									<></>
								)}

								{!fileImagesUpload.length ? (
									<div className='inputBox'>
										<FontAwesomeIcon icon={faImage} size={'3x'} />
									</div>
								) : (
									<></>
								)}
							</div>
						</section>
					);
				}}
			</Dropzone>
			<div className='imageList'>
				{imagesData.map((image) => {
					const imageURL = `http://www.icontroler.com.br/${image.CAMINHOARQUIVO}/${image.NOMEARQUIVO}`;
					return (
						<div className='imageDiv' key={image.NOMEARQUIVO}>
							<FontAwesomeIcon
								className='iconClose'
								onClick={() => {
									handleDialog(image);
								}}
								icon={faTrash}
								size={'1x'}
								cursor='pointer'
							/>
							<img
								src={imageURL}
								className='imageDropped'
								height={80}
								width={80}
								alt={'Imagem para upload'}
							/>
							<Dialog
								header='Deletar imagem'
								footer={deleteVehicleDialogFooter}
								onHide={() => {
									handleDialog();
								}}
								visible={dialogOpen}
								modal>
								<div className='confirmation-content'>
									<i className='pi pi-exclamation-triangle p-mr-3' style={{ fontSize: '2rem' }} />
									<span>Tem certeza que deseja deletar esta imagem permanentemente?</span>
								</div>
							</Dialog>
						</div>
					);
				})}

				{imagePreview.map((file: string, index: number) => (
					<div className='imageDiv' key={file}>
						<FontAwesomeIcon
							className='iconClose'
							onClick={() => handleDelete(index)}
							icon={faTimes}
							size={'1x'}
							cursor='pointer'
						/>
						<img src={file} alt={file} className='imageDropped' height={80} width={80} />
					</div>
				))}
			</div>
		</div>
	);
};

export default DropzoneScreen;
